import { createFileRoute } from "@tanstack/react-router";
import { EntityFormPage } from "@/components/entity-page/EntityFormPage";
import CreateLanguageForm from "@/components/CreateLanguageForm";

export const Route = createFileRoute("/dashboard/settings/languages/new")({
  component: CreateLanguagePage,
});

function CreateLanguagePage() {
  return <CreateLanguagePageComponent />;
}

// Exported for testing
export function CreateLanguagePageComponent() {
  return (
    <EntityFormPage
      title="Create Language"
      description="Add a new language to the catalog."
      backHref="/dashboard/settings/languages"
    >
      <CreateLanguageForm />
    </EntityFormPage>
  );
}
